import React, { useState } from "react";
import { toast } from "sonner";
import { User, Wallet } from "lucide-react";
import { PUBLISHER } from "../demoData";
import { Card, CardHead, PageTitle, Btn, inputCls } from "../ui";

const Field = ({ label, children }) => (
  <label className="block">
    <span className="block text-xs font-semibold text-slate-400 mb-1.5">{label}</span>
    {children}
  </label>
);

export default function Profile() {
  const [p, setP] = useState(PUBLISHER);
  const set = (k) => (e) => setP((x) => ({ ...x, [k]: e.target.value }));
  const save = (e) => { e.preventDefault(); toast.success("Profile saved (demo — not stored)"); };

  return (
    <>
      <PageTitle title="Profile" sub={`${p.id} · Member since ${p.joined} · ${p.tier} tier`} />
      <form onSubmit={save} className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="profile-form">
        <Card testId="profile-company">
          <CardHead icon={User} title="Company Details" />
          <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label="Full Name"><input className={inputCls} value={p.name} onChange={set("name")} data-testid="profile-name" /></Field>
            <Field label="Company"><input className={inputCls} value={p.company} onChange={set("company")} data-testid="profile-company-input" /></Field>
            <Field label="Email"><input className={inputCls} value={p.email} onChange={set("email")} data-testid="profile-email" /></Field>
            <Field label="Phone"><input className={inputCls} value={p.phone} onChange={set("phone")} data-testid="profile-phone" /></Field>
            <div className="sm:col-span-2">
              <span className="block text-xs font-semibold text-slate-400 mb-1.5">Traffic Sources</span>
              <div className="flex flex-wrap gap-2">
                {p.sources.map((s) => <span key={s} className="text-xs px-3 py-1 rounded-full bg-blue-500/15 text-blue-300">{s}</span>)}
              </div>
            </div>
          </div>
        </Card>
        <Card testId="profile-payout">
          <CardHead icon={Wallet} title="Payout Method" />
          <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label="Method">
              <select className={inputCls} value={p.payoutMethod} onChange={set("payoutMethod")} data-testid="profile-payout-method">
                {["Wire Transfer", "PayPal", "Wise", "ACH"].map((m) => <option key={m}>{m}</option>)}
              </select>
            </Field>
            <Field label="Payout Terms">
              <select className={inputCls} value={p.payoutTerms} onChange={set("payoutTerms")} data-testid="profile-payout-terms">
                {["Weekly Net 7", "Monthly Net 10"].map((m) => <option key={m}>{m}</option>)}
              </select>
            </Field>
            <Field label="Account"><input className={inputCls} value={p.bank} onChange={set("bank")} data-testid="profile-bank" /></Field>
            <Field label="Country"><input className={inputCls} value={p.country} onChange={set("country")} data-testid="profile-country" /></Field>
          </div>
        </Card>
        <div className="lg:col-span-2 flex justify-end">
          <Btn type="submit" data-testid="profile-save">Save Changes</Btn>
        </div>
      </form>
    </>
  );
}
